import { render, staticRenderFns } from "./OnboardingDenied.vue?vue&type=template&id=6a1e47e6&scoped=true"
import script from "./OnboardingDenied.vue?vue&type=script&lang=js"
export * from "./OnboardingDenied.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDenied.vue?vue&type=style&index=0&id=6a1e47e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1e47e6",
  null
  
)

export default component.exports